"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderTreeNodeSchema = exports.FolderNodeSchema = void 0;
const zod_1 = require("zod");
exports.FolderNodeSchema = zod_1.z.object({
    folderId: zod_1.z.number(),
    name: zod_1.z.string().nullable(),
    code: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    parentId: zod_1.z.number().nullable(),
    orgId: zod_1.z.number().nullable(),
    sortOrder: zod_1.z.number().nullable(),
    path: zod_1.z.string().nullable(),
    pathName: zod_1.z.string().nullable(),
    isActive: zod_1.z.boolean(),
});
exports.FolderTreeNodeSchema = exports.FolderNodeSchema.extend({
    children: zod_1.z.lazy(() => zod_1.z.array(exports.FolderTreeNodeSchema)),
});
